import React, { useEffect, useState } from 'react'
import { Bar, HorizontalBar } from 'react-chartjs-2'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import { ColumnChartWrapper } from '../dashboard.styled'
import { DashboardSources, DefaultColor } from '../../../constants/DashboardConf'
import ChartHeader from './ChartHeader'

function ColumnChart (props) {
  const { data: d, settingMode, useFakeData } = props
  const { UISetting, tableName, categoryDetail, content } = d || {}
  const { title, xAxis, limit, style } = UISetting || {}
  const [data, setData] = useState([])
  const [multipleTitle, setMultipleTitle] = useState([])
  const theme = Object.values(style?.themeColor || {})
  const colorTheme = theme?.length ? theme : DefaultColor

  const defaultConf = { hoverOffset: 4 }
  const chartProps = {
    data: {
      datasets: multipleTitle?.length
        ? multipleTitle?.map((title, idx) => ({
          label: title,
          data: data?.map(i => Number(i[title])),
          backgroundColor: colorTheme[idx + 1],
          ...defaultConf
        }))
        : [{
            label: title,
            data: data?.map(i => i.value),
            backgroundColor: colorTheme,
            ...defaultConf
          }],
      labels: data?.map(i => i.label)
    },
    options: {
      plugins: { datalabels: false },
      legend: { display: false },
      interaction: { mode: 'index', intersect: true },
      tooltips: { mode: 'x-axis', intersect: true, displayColors: false }
    },
    plugins: [ChartDataLabels],
    height: 180
  }

  const useFake = useFakeData && categoryDetail === DashboardSources.THIRD_PARTY
  useEffect(() => {
    if (!settingMode && !useFake && !content?.data) return
    const fakeData = Array.from({ length: limit || 5 }, (v, i) => (i + 1) * 10).reverse().map((i, idx) => ({ label: `${xAxis || tableName || categoryDetail} ${idx + 1}`, value: i }))
    if (settingMode || useFake) return setData(fakeData)
    const titles = Object.keys(content?.data?.[0] || [])?.filter(i => i !== 'label' && i !== 'value')
    setMultipleTitle(titles)
    setData(content?.data)
  }, [content])

  return (
    <>
      <ChartHeader {...props} />
      <ColumnChartWrapper>
        {style?.chartStyle === 'bar' ? <HorizontalBar {...chartProps} /> : <Bar {...chartProps} />}
      </ColumnChartWrapper>
    </>
  )
}

export default ColumnChart
